var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('new-group-form',{on:{"group-changed":_vm.refreshGroupList}}),_vm._v(" "),_c('group-list',{ref:"groupList",attrs:{"can_manage_groups":"","title":"Groups"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }